import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer>
      <p>Copyright © {currentYear} OVERSEAS EDUCATION PLATFORM. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
